<template lang="html">

    <div class="view-loading"></div>

</template>

<script lang="js">

    import {mapActions,mapGetters} from 'vuex';

    export default {
        name: 'logout',
        mounted(){
            this.requestLogout().then(r => {
                if(r){
                    if(this.isEstudiante){
                        location.href = "/login/alumnos";
                    }else if(this.isAlumni){
                        location.href = "/login/antiguos";
                    }if(this.isEmpresa){
                        location.href = "/login/empresas";
                    }
                }
            });
        },
        computed : {
            ...mapGetters({
                isAlumni : 'isAlumni',
                isEstudiante : 'isEstudiante',
                isEmpresa : 'isEmpresa',
            })
        },
        methods : {
            ...mapActions(['requestLogout'])
        }
    }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/logout.vue